import * as React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { NamedMode } from '../../types/Common';
import { useAppDispatch } from '../../store';
import Loader from '../general/Loader';
import { Link } from 'react-router-dom';
import { useFetchOperation } from '../../service/Operation';
import { trainingActionCreators } from '../../store/Training';
import { ModeSetting, ModeSettingSlim } from '../../types/TrainingTypes';
import Alerts from '../general/Alerts';
import ProgressButton from '../general/ProgressButton';
import ModeSettingEditor from './ModeSettingEditor';
import Error from '../general/Error';

export default function ModeSettingButton(props: {
    mode: NamedMode,
}) {
    const [modalShow, setModalShow] = React.useState(false);

    return <>
        <Button variant="outline"
            className="align-middle btn btn-sm p-1"
            onClick={() => setModalShow(true)}>
            <svg fill="gray"
                width="18"
                height="18"
                viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m487.4 315.7-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3l-42.6 24.6c-17.9-15.4-38.5-27.3-60.8-35.1v-49.1c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7v49.2c-22.2 7.9-42.8 19.8-60.8 35.1l-42.5-24.6c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14l42.6 24.6c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zm-231.4 20.3c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" /></svg>
        </Button>
        {modalShow &&
            <ModeSettingModal show={modalShow} mode={props.mode} setShow={setModalShow} />
        }
    </>
}

function ModeSettingModal(props: { show: boolean, mode: NamedMode, setShow: (x: boolean) => void }) {
    const dispatch = useAppDispatch();
    const { show, mode, setShow } = props;
    const [setting, setSetting] = React.useState<ModeSetting>();
    const [getting, startGetting] = useFetchOperation(setSetting, undefined, true);
    const [editing, startEditing, resetEditing] = useFetchOperation(onEditingSuccess);

    React.useEffect(() => {
        startGetting('get', `api/study/settings/mode-setting?dictionaryId=${mode.dictionaryId}&isDirect=${mode.isDirect}`);
    }, [mode]);

    function onSave() {
        startEditing('post', `api/study/settings/mode-setting`, setting);
    }

    function onEditingSuccess() {
        dispatch(trainingActionCreators.setModeSetting(setting!));
    }

    function setSettingSlim(settingSlim: ModeSettingSlim) {
        setSetting({ ...mode, ...setting!, ...settingSlim });
    }

    return (
        <>
            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Settings for<> </>
                        <Link to={`/dictionaries/${mode.dictionaryId}`}
                            className="mb-1 fw-bold">{mode.dictionaryName}</Link>,<> </>
                        {mode.isDirect ? 'direct' : 'inverse'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {getting.active ?
                        <Loader />
                        :
                        !setting ?
                            <Error text={getting.error} />
                            :
                            <div className="text-center">
                                <div className="mt-1">
                                    <ModeSettingEditor setting={setting}
                                        setSetting={setSettingSlim}
                                        isGetting={getting.active} />
                                </div>
                                <Alerts error={editing.error}
                                    onClose={resetEditing} />

                            </div>
                    }
                </Modal.Body>

                <Modal.Footer>
                    <ProgressButton className="my-3 btn-wide"
                        onClick={onSave}
                        disabled={getting.active}
                        active={editing.active}
                        success={editing.success} />

                    <Button variant="secondary"
                        onClick={() => setShow(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
